import { Avatar, makeStyles } from '@fluentui/react-components';

import { initialsOf } from '../common';
import type { WorkItem } from '../common/models';
import { useMemberAvatar } from '../current-user';
import { palette } from '../theme';

export type WorkItemAssigneeProps = {
    item: WorkItem;
    size?: 24 | 28 | 32 | 36;
};

// The ADO assignee's avatar. Keeps its footprint whether or not the item is
// assigned, so rows in a list stay aligned.
export const WorkItemAssignee: React.FC<WorkItemAssigneeProps> = ({ item, size = 32 }) => {
    const classes = useStyles();
    const email = item.assignedToEmail ?? '';
    const name = item.assignedToName ?? email;
    const avatarUrl = useMemberAvatar(email);

    if (!email) {
        return <span className={classes.unassigned} style={{ width: size, height: size }} title="Unassigned" aria-label="Unassigned" />;
    }

    return (
        <Avatar
            name={name}
            image={avatarUrl ? { src: avatarUrl } : undefined}
            initials={initialsOf(name)}
            size={size}
            title={`Assigned to ${name}`}
        />
    );
};

const useStyles = makeStyles({
    unassigned: {
        display: 'inline-block',
        borderRadius: '50%',
        border: `1px dashed ${palette.outlineGray}`,
        flexShrink: 0,
    },
});
